import { dateToEpoch } from 'helper/helper';

/**
 * Generate an array of weeks between two epoch timestamps.
 * Each week is an array of epoch timestamps, splitting on Sundays.
 */
export const timeSheets = (startEpoch, endEpoch) => {
  const weeks = [];
  let current = new Date(startEpoch);
  const endDate = new Date(endEpoch);
  let week = [];

  while (current <= endDate) {
    week.push(dateToEpoch(current));

    // If we've reached the end or a Sunday, close out the current week
    if (current >= endDate || current.getDay() === 0) {
      weeks.push(week);
      week = [];
    }
    current.setDate(current.getDate() + 1);
  }

  return weeks;
};
